import { Link } from "@tanstack/react-router";

const TABS = [
  { to: "/settings/integrations", label: "Integrations" },
  { to: "/settings/billing", label: "Billing" },
] as const;

/** Shared sub-navigation across the settings pages. */
export function SettingsNav() {
  return (
    <nav className="flex gap-1">
      {TABS.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          className="rounded-md px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
          activeProps={{ className: "bg-accent font-medium text-foreground" }}
          activeOptions={{ exact: true }}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  );
}
